'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var expandableCell = require('./expandable-cell-8030b7aa.js');

var TableRow = styled__default.tr(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var hasShadow = _a.hasShadow, theme = _a.theme;
    return hasShadow && styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    box-shadow: 0px 10px 8px -4px ", ";\n  "], ["\n    box-shadow: 0px 10px 8px -4px ", ";\n  "])), theme.colorsRgba.adminBlack_12);
});
var DataRow = function (_a) {
    var dataCy = _a.dataCy, dataTestId = _a.dataTestId, columns = _a.columns, rowIndex = _a.rowIndex, row = _a.row, _b = _a.nestingLevel, nestingLevel = _b === void 0 ? 0 : _b, _c = _a.parents, parents = _c === void 0 ? [] : _c, onToggleRow = _a.onToggleRow, isLastLeaf = _a.isLastLeaf;
    var isExpanded = row.childRowsExpanded || row.childRowsLoading;
    var hasShadow = isLastLeaf || (isExpanded && nestingLevel === 0);
    return (React__default.createElement(TableRow, { "data-cy": dataCy && dataCy + "-row", "data-testid": dataTestId && dataTestId + "-row", hasShadow: hasShadow }, columns.map(function (cell, cellIndex) { return (React__default.createElement(expandableCell.ExpandableCell, { className: "cell cell-" + (cell === null || cell === void 0 ? void 0 : cell.id), key: "row-" + rowIndex + "-cell-" + (cell === null || cell === void 0 ? void 0 : cell.id), center: cell === null || cell === void 0 ? void 0 : cell.center, cellIndex: cellIndex, onToggleRow: onToggleRow, row: row, parents: parents, nestingLevel: nestingLevel, hidden: cell === null || cell === void 0 ? void 0 : cell.hidden }, row[cell === null || cell === void 0 ? void 0 : cell.id])); })));
};
var templateObject_1, templateObject_2;

exports.DataRow = DataRow;
